<div
  class="integration-card d-flex align-items-center"
  [class.active]="active"
  (click)="onCardClick($event)"
  tabindex="0"
  role="button"
  [attr.aria-selected]="active"
>
  <!-- Logo or Icon -->
  <div
    class="integration-icon me-3"
    *ngIf="logo || icon"
  >
    <ng-container *ngIf="logo; else iconBlock">
      <img
        [src]="logo"
        alt="logo"
        class="img-fluid"
        style="max-width: 32px; max-height: 32px"
      />
    </ng-container>
    <ng-template #iconBlock>
      <ng-container *ngIf="isTemplateRef(icon); else iconClass">
        <ng-container *ngTemplateOutlet="getTemplateRef(icon)"></ng-container>
      </ng-container>
      <ng-template #iconClass>
        <i
          *ngIf="icon"
          [ngClass]="icon"
        ></i>
      </ng-template>
    </ng-template>
  </div>

  <!-- Main Content -->
  <div class="integration-details flex-grow-1">
    <h6 class="mb-1">{{ title }}</h6>
    <p
      *ngIf="description"
      class="text-muted small mb-0"
    >
      {{ description }}
    </p>
    <ng-container *ngIf="customContent">
      <ng-container *ngTemplateOutlet="customContent"></ng-container>
    </ng-container>
    <span
      *ngIf="badge"
      class="integration-type-tag ms-2"
      [ngClass]="badgeClass"
      >{{ badge }}</span
    >
  </div>

  <!-- Status -->
  <div
    *ngIf="status"
    class="status-badge ms-2"
    [ngClass]="statusClass"
  >
    {{ status }}
  </div>
</div>
